export enum SurveyEnum {
	CONTACT_FORM = "CONTACT_FORM",
	ADD_LOCATION = "ADD_LOCATION",
	DASHBOARD = "DASHBOARD"
}